/**
 * GPUParticlesCollisionSDF3D's configuration warning for a zero `bake_mask`
 * (gpu_particles_collision_3d.cpp:526-534), the only such override among the
 * collision and attractor classes. It needs only the node's own `bake_mask`, so
 * the whole check ports.
 */
import { ruleRegistry } from '../../../../../linter/RuleRegistry.js';
import { descendsFromClass } from '../../../../../godot/classdb/classBaseTypes.js';
import { ruleInt } from '../../../../../godot/variant/intSlots.js';
import { armDiagnostic, armEmits, groundedArm } from '../../../../../linter/ruleArms.js';
const arms = {
    emptyBakeMask: groundedArm('gpuparticlescollisionsdf3d-empty-bake-mask', { kind: 'configuration-warning' }),
};
function checkGPUParticlesCollisionSDF3D(context) {
    const { node } = context;
    const rawProps = node.rawProperties;
    // `bake_mask` defaults to 4294967295, all layers (gpu_particles_collision_3d.cpp:557), and
    // the serialiser omits a default, so only an explicit `bake_mask = 0` fires.
    if (rawProps.bake_mask === undefined)
        return [];
    // uint32_t setter (gpu_particles_collision_3d.h:183).
    if (ruleInt(rawProps.bake_mask, null, 'uint32') !== 0)
        return [];
    return [
        armDiagnostic(arms.emptyBakeMask, node, `GPUParticlesCollisionSDF3D '${node.name}' has a Bake Mask with no bits enabled, which means baking will not produce any collision for it. Enable at least one bit in the Bake Mask property.`),
    ];
}
const gpuParticlesCollisionSDF3DBakeMaskRule = {
    meta: {
        name: 'valid-gpuparticlescollisionsdf3d-bake-mask',
        description: "Warns when a GPUParticlesCollisionSDF3D's Bake Mask has no bits enabled, so baking would produce no collision",
        category: 'validation',
        applicableNodeTypeMatcher: (nodeType) => descendsFromClass(nodeType, 'GPUParticlesCollisionSDF3D'),
        emits: armEmits(arms),
    },
    check: checkGPUParticlesCollisionSDF3D,
};
ruleRegistry.register(gpuParticlesCollisionSDF3DBakeMaskRule);
//# sourceMappingURL=linter.js.map